import { avatar, logoSymbol } from "@/assets";
import MobileNav from "./MobileNav";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";
import { useState, useRef, useEffect } from "react";
import { Confirm } from "notiflix";
import { Moon, Sun } from "lucide-react";
import { useSelector } from "react-redux";
import { PostRequest } from "@/lib/http";
import { resolveImageUrl } from "@/lib/utils";

const TopNavbar = ({ platform }) => {
  const { theme, toggleTheme } = useTheme();
  const pathname = useLocation().pathname;
  const [toggle, setToggle] = useState(false);
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const confirmation = async () => {
    Confirm.show(
      "Confirm Action",
      `Are you sure you want to logout?`,
      "Yes, Proceed",
      "Cancel",
      async () => {
        navigate("/login");
        localStorage.removeItem("user-token");
        await PostRequest({
          url: "/api/admin/logout",
        });
      },
    );
  };

  // This function is for Dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggle(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <nav
      className={`font-manrope dark:border-b-darkBorder/50 dark:bg-darkBg ${platform != "web" ? "pt-10" : "p-0"} fixed z-50 flex w-full items-center justify-between border-b border-b-gray-100 bg-white px-[3%] py-2 md:hidden`}
    >
      <div>
        <MobileNav />
      </div>

      <Link to="/dashboard" className="flex items-center gap-1">
        <img src={logoSymbol} alt="logo-symbol" className="size-7" />
        <h2 className="font-geist text-2xl font-bold text-black/80 dark:text-white">
          Billzpay
        </h2>
      </Link>

      <div className="flex items-center gap-x-2">
        {pathname !== "/dashboard/account" && (
          <div
            onClick={toggleTheme}
            className="flex cursor-pointer items-center justify-center rounded-sm bg-gray-200 p-2 transition-colors duration-300 dark:bg-gray-800"
            title="Toggle Theme"
          >
            {theme === "dark" ? (
              <Sun size={22} className="text-yellow-500" />
            ) : (
              <Moon size={22} className="text-orange-500" />
            )}
          </div>
        )}

        <div onClick={() => setToggle((prev) => !prev)} className="">
          <img
            src={user.avatar ? resolveImageUrl(user.avatar) : avatar}
            alt="avatar"
            className="size-10 rounded-full object-cover"
          />
        </div>
      </div>

      {toggle && (
        <div
          ref={dropdownRef}
          className="dark:border-darkBorder dark:bg-darkInput absolute top-14 right-4 z-10 mt-2 w-48 rounded-lg border bg-white py-1 shadow-lg"
        >
          <Link
            to="/dashboard/account"
            onClick={() => {
              setToggle(false);
              scrollTo(0, 0);
            }}
            className="block px-4 py-2 text-sm text-gray-700 dark:text-white"
          >
            Your Profile
          </Link>

          <h2
            onClick={confirmation}
            className="block cursor-pointer px-4 py-2 text-sm text-gray-700 dark:text-white"
          >
            Sign out
          </h2>
        </div>
      )}
    </nav>
  );
};

export default TopNavbar;

const dropdownVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
    x: 0,
    transformOrigin: "top right",
  },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transformOrigin: "top right",
    transition: {
      duration: 0.1,
      ease: "linear",
    },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    x: 0,
    transformOrigin: "top right",
    transition: {
      duration: 0.1,
      ease: "linear",
    },
  },
};
